/**
 * Chart storage — localStorage-based persistence for saved charts.
 * Shared between Navbar (profile selector) and ChartPage.
 */

const STORAGE_KEY = 'antardristi_charts';
const ACTIVE_KEY = 'antardristi_active_profile';

export function getSavedCharts() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
  } catch { return {}; }
}

export function getSavedNames() {
  return Object.keys(getSavedCharts()).sort();
}

export function getChart(name) {
  const all = getSavedCharts();
  return all[name] || null;
}

export function saveChart(name, formData, chartData) {
  const all = getSavedCharts();
  all[name] = { form: formData, chart: chartData, savedAt: new Date().toISOString() };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(all));
}

export function deleteChart(name) {
  const all = getSavedCharts();
  delete all[name];
  localStorage.setItem(STORAGE_KEY, JSON.stringify(all));
  if (getActiveProfile() === name) setActiveProfile('');
}

export function getActiveProfile() {
  return localStorage.getItem(ACTIVE_KEY) || '';
}

export function setActiveProfile(name) {
  localStorage.setItem(ACTIVE_KEY, name);
}
